import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  getAssetDetailById,
  getAssetPaymentDetailById,
  getAssetPaymentsListItems,
  getAssetPaymentsCommissionDetailById,
  getAssetPaymentsCommissionsListItems,
  getAssetCommissionsDistributionDetailById,
  getAssetCommissionsDistributionListItems,
} from "../../../../redux/Case/assetSlice";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import { getCaseCategoryByCaseType } from "../../../../utils";
import { Label, Toaster } from "@fluentui/react-components";
import { makeStyles, tokens } from "@fluentui/react-components";
import CaseDetailDrawer from "../CaseDetailDrawer";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function AssetCommissionDistribution({ tab }: { tab?: string }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { clientId, action, caseId, subItemId, subSubItemId, distributionId } =
    useParams();
  const dispatch: AppDispatch = useDispatch();
  const { showToast, toasterId } = useToastMessage();
  const [currentRecord, setCurrentRecord] = useState(1);

  const assets = useSelector((state: RootState) => state.assets);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const [caseType, setCaseType] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>("distribution");
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId && subItemId && subSubItemId) {
      dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
      dispatch(getAssetPaymentDetailById(subItemId));
      dispatch(
        getAssetPaymentsCommissionsListItems({
          paymentId: subItemId,
          caseId,
          customerId: clientId,
        })
      );
      dispatch(
        getAssetCommissionsDistributionListItems({
          commissionId: subSubItemId,
        })
      );
    }
  }, [caseId, clientId, subItemId, subSubItemId, dispatch]);

  useEffect(() => {
    if (assets?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(assets.activeItem.case_type));
    }
  }, [assets?.activeItem]);

  useEffect(() => {
    if (subItemId && assets?.payments?.listItems?.length > 0) {
      dispatch(getAssetPaymentDetailById(subItemId));
    }
  }, [subItemId, activeTab, assets?.payments?.listItems, dispatch]);

  useEffect(() => {
    if (subSubItemId && assets?.payments?.commissions?.listItems?.length > 0) {
      dispatch(getAssetPaymentsCommissionDetailById(subSubItemId));
    }
  }, [
    subSubItemId,
    activeTab,
    assets?.payments?.commissions?.listItems,
    dispatch,
  ]);

  useEffect(() => {
    if (
      distributionId &&
      assets?.payments?.commissions?.distribution?.listItems?.length > 0
    ) {
      dispatch(getAssetCommissionsDistributionDetailById(distributionId));
    }
  }, [
    dispatch,
    subSubItemId,
    distributionId,
    activeTab,
    assets?.payments?.commissions?.distribution?.listItems,
  ]);
  //const paymentId = assets?.payments?.listItems[0]?.payment?.payment_id;
  const paymentId =
    subItemId || assets?.payments?.listItems[0]?.payment?.payment_id;
  const commissionId =
    subSubItemId || assets?.payments?.commissions?.listItems[0]?.commission_id;
  const distributionID =
    distributionId ||
    assets?.payments?.commissions?.distribution?.listItems[0]
      ?.commission_allocation_id;

  useEffect(() => {
    if (!paymentId || !caseId || !commissionId || !distributionID) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/${distributionID}/distribution/view`
      );
    } else if (action === "add") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/add`
      );
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/${distributionID}/distribution/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/${distributionID}/distribution/view`
      );
    }
  }, [
    clientId,
    action,
    caseId,
    paymentId,
    commissionId,
    distributionID,
    assets?.payments?.commissions?.distribution?.listItems,
    tab,
    navigate,
  ]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="payments"
        section="assets"
        tab={activeTab}
        caseType={caseType}
        caseDetail={assets.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        {(action === "add" ||
          assets?.payments?.commissions?.distribution?.listItems?.length >
            0) && (
          <CaseForm
            currentRecord={currentRecord}
            setCurrentRecord={setCurrentRecord}
            mode={action || ""}
            section="assets"
            caseType={caseType}
            caseDetail={assets?.payments?.commissions?.distribution?.activeItem}
            caseItemList={
              assets?.payments?.commissions?.distribution?.listItems
            }
            tab={activeTab}
            subItem="payments"
            notify={showToast}
          />
        )}

        <div>
          {assets?.payments?.commissions?.distribution?.loading ? (
            <ContentLoader />
          ) : assets?.payments?.commissions?.distribution?.listItems?.length >
            0 ? (
            <CaseList
              currentRecord={currentRecord}
              setCurrentRecord={setCurrentRecord}
              module="distribution"
              data={assets?.payments?.commissions?.distribution?.listItems}
              activeItem={
                assets?.payments?.commissions?.distribution?.activeItem
              }
              section="assets"
              activeTab={tab}
            />
          ) : (
            // ✅ Only show NoDataFound if not in "add" mode
            action !== "add" && <NoDataFound />
          )}
        </div>
      </div>

      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={assets?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default AssetCommissionDistribution;
